import React from "react";
import { Instagram, MessageCircle } from "lucide-react";
import { useContent } from "@/context/ContentContext";

export default function SocialFloat() {
  const CLINIC = useContent();
  return (
    <div data-testid="social-float" className="fixed bottom-24 right-4 z-40 flex flex-col gap-3 lg:bottom-8 lg:right-8">
      <a
        href={CLINIC.instagram}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Follow us on Instagram"
        data-testid="float-instagram"
        className="group inline-flex h-12 w-12 items-center justify-center rounded-full border border-gold/30 bg-cream/90 text-terracotta shadow-card backdrop-blur transition-[transform,background-color,color] duration-300 hover:-translate-y-1 hover:bg-terracotta hover:text-cream"
      >
        <Instagram className="h-5 w-5" />
      </a>
      <a
        href={`https://wa.me/${CLINIC.whatsappDigits}?text=${encodeURIComponent("Hello, I would like to book an appointment at Dr. Mithee's Clinic for Women.")}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        data-testid="float-whatsapp"
        className="relative inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lift transition-transform duration-300 hover:-translate-y-1 active:scale-95"
      >
        <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366]/40 [animation-duration:2.4s]" aria-hidden="true" />
        <MessageCircle className="relative h-6 w-6" />
      </a>
    </div>
  );
}
